import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getRoutes } from "../routes";

import './navbar.css';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import { deepPurple } from '@material-ui/core/colors';

import { authenticationService } from '../services/auth.service';
import UserLogin from "../models/UserLogin";
import { UserRoleEnum } from "../models/enums/UserRoleEnum";
import AutoComplete from "./AutoComplete";
import IAutoCompleteObject from "../models/IAutoCompleteObject";
import { useAuth } from "./auth/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOut } from "@fortawesome/free-solid-svg-icons";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    purple: {
      color: theme.palette.getContrastText(deepPurple[500]),
      backgroundColor: deepPurple[500],
    }
  })
);

const Navbar = () => {
  const [userLogged, setUserLogged] = useState<UserLogin>();
  const [dataMembersOpts, setDataMembersOpts] = useState<[]>([]);
  const { logout } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const classes = useStyles();
  const [userRoles, setUserRoles] = useState<UserRoleEnum[]>([]);
  const routes = getRoutes();

  useEffect(() => {
    const subscription = authenticationService.currentUser.subscribe((value) => {
      setUserLogged((value ?? undefined) as UserLogin | undefined);
      setUserRoles(value?.roles ?? []);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleClickItemMenu = () => {
    const ele = document.getElementById("menu-toggle");
    if (ele) {
      ele.click();
    }
  }

  if (pathname.indexOf('entrar') > -1) {
    return null;
  }

  if (pathname.indexOf('/reuniao/em-andamento') < 0) {
    const ele = document.getElementById("navbar-main");
    if (ele) {
      ele.className = 'uk-navbar uk-navbar-container uk-margin';
    }
  }

  const onAfterAutoCompleteChange = async (selected: IAutoCompleteObject) => {
    if (selected && selected.id > 0) {
      navigate(`/membros/${selected.id}`);
      if (window.location.pathname.indexOf('/membros/') === 0) {
        window.location.reload();
      }
    }
  }

  return (
    <>
    <nav className="uk-navbar uk-navbar-container uk-margin" id="navbar-main">
      <div className="uk-navbar-left">
        <a className="uk-navbar-toggle"
          href="#"
          uk-toggle="target: #offcanvas-nav-primary"
          id="menu-toggle"
        >
          <span uk-icon="icon: menu"></span>
        </a>
      </div>
      {(userLogged && authenticationService.hasAnyRole(authenticationService.accessMembersRoles())) && (
        <div className="uk-navbar-center uk-flex-wrap" style={{width: '30vw'}}>
          <label className="uk-form-label uk-margin-small-right">Pesquise Membro Por Nome</label>
          <AutoComplete
            urlFetch="members/name/"
            suggestions={dataMembersOpts}
            onAfterChange={onAfterAutoCompleteChange}
          />
        </div>
      )}
      {userLogged &&
        <div className="uk-navbar-right">
          <div className="uk-flex uk-flex-column uk-text-right">
            <label style={{ fontSize: 10}}>
              {userLogged.name}
            </label>
            <label style={{fontSize: 10}}>
              {authenticationService.userRole()}
              {(userLogged.congregations && userLogged.congregations?.length > 0) && (<span><br/>({userLogged.congregations?.map(c => c.description).join(', ')})</span>)}
            </label>
          </div>
          <div className="uk-margin-right uk-text-center">
            <div className={classes.root}>
              <Avatar className={classes.purple}>
                <label uk-tooltip={`title: ${userLogged.name}; pos: left`}>
                  {userLogged.name.toUpperCase().split(" ")[0][0]}
                  {userLogged.name.toUpperCase().split(" ").length > 1 && userLogged.name.toUpperCase().split(" ")[1][0]}
                </label>
              </Avatar>
            </div>
          </div>
        </div>
      }
    </nav>
      <div id="offcanvas-nav-primary" 
        uk-offcanvas="overlay: false; mode: push; flip: false;"
      >
        <div className="uk-offcanvas-bar uk-flex uk-flex-column">
          <ul className="uk-nav uk-nav-primary uk-nav-center uk-margin-auto-vertical uk-nav-parent-icon uk-overflow-auto@s"
            uk-nav="multiple: true">
            {routes.filter((r: any) => r?.icon && r?.path !== '/').map((r: any) => {
              if (userLogged) {
                const hasChildren = r.children && r.children.length > 0;
                const isAllowed = (r.allowed && userRoles.some((role: UserRoleEnum) => r.allowed?.includes(role))) || r.path === '/inicio';
                const isParentActive = pathname.indexOf(r.path) >= 0 && r.children && r.children.length > 0;
                if (isAllowed) {
                  return (
                    <li className={`${isParentActive ? "uk-active" : ""} ${hasChildren && 'uk-parent'}`} key={r.label}>
                      <Link to={r.path}
                        onClick={!hasChildren ? handleClickItemMenu : () => {}}
                        className="uk-flex-center uk-flex-middle"
                      >
                        {r.icon && <FontAwesomeIcon className="uk-margin-small-right" icon={r.icon} />}
                        <span>{r.label}</span>
                        {hasChildren && <span uk-nav-parent-icon="true"></span>}
                      </Link>
                      {hasChildren &&
                        <ul className="uk-nav-sub">
                          {
                            r.children.map((child: any) => {
                              const isChildActive = pathname === child.path;
                              const isChildAllowed = (child.allowed && userRoles.some((role: UserRoleEnum) => child.allowed?.includes(role))) || r.path === '/inicio';
                              if (isChildAllowed) {
                                return <li 
                                  key={child.label} 
                                  className={`${isChildActive ? "uk-active" : ""} uk-flex uk-flex-center`}
                                >
                                  <Link to={child.path}
                                    onClick={handleClickItemMenu}
                                  >
                                    {child.label}
                                  </Link>
                                </li>
                              }
                              
                            })
                          }
                        </ul>
                      }
                    </li>
                  )
                }
              }})
            }
            <li key={'logout'}>
              <a href="#" onClick={(ev) => { 
                ev.preventDefault(); 
                authenticationService.logout('');
                logout();
              }}
                className="uk-flex-center uk-flex-middle"
              >
                <FontAwesomeIcon className="uk-margin-small-right" icon={faSignOut} />
                <span>Sair</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  )    
}

export default Navbar;
